import React, { useEffect } from "react";
import ModalComponent from "../../../components/modalComponent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ButtonComponent from "../../../components/button";
import SearchableSelectInput from "../../../components/selectInput/searchableSelectInput";

const CreateBillingUnitModal = ({
  enterpriseOptions,
  open,
  onClose,
  onSubmitFunction
}) => {
  const schema = yup.object().shape({
    name: yup.string().required("Seleccione el tenant (EnterpriseKey)")
  });

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: ""
    }
  });

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open, reset]);

  const handleFormSubmit = (formData) => {
    onSubmitFunction({ ...formData, status: 1 });
    reset();
    onClose();
  };

  const options = (enterpriseOptions || []).map((item) => ({
    value: item.id ?? item.Id,
    label: `${item.id ?? item.Id} — ${item.name ?? item.Name ?? ""}`
  }));

  return (
    <ModalComponent
      open={open}
      onClose={() => {
        reset();
        onClose();
      }}
      onSubmit={handleSubmit(handleFormSubmit)}
      title={"Agregar licencia / unidad de facturación"}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <SearchableSelectInput
          name="name"
          control={control}
          label="Tenant (EnterpriseKey desde IntelappSys)"
          options={options}
        />

        <div className="HContainer j-center mt-20">
          <ButtonComponent
            type="submit"
            backgroundColor="#F6C079"
            textColor="#000000"
            width="160px"
          >
            Guardar
          </ButtonComponent>
        </div>
      </form>
    </ModalComponent>
  );
};

export default CreateBillingUnitModal;
